<script lang="ts">
  import { PUBLIC_DO_ASSETS_URL } from '$env/static/public';

  import { afterUpdate, createEventDispatcher } from 'svelte';

  import { CommonDto } from '@do/data-transfer-objects';

  import { cn } from '@shared/utils';

  import { ANIMATED_FORMATS, IMAGE_FORMATS, VIDEO_FORMATS } from '../configs';
  import Image from './image.svelte';
  import PreviewImage from './preview-image.svelte';
  import Video from './video.svelte';

  export let filename: string | null | undefined;
  export let type: string | null | undefined = undefined;
  export let captionsSrc: string | undefined = undefined;
  export let previewImage: CommonDto.Photo | null = null;
  export let title: string = 'Media content';
  export let isLoaded: boolean = false;
  export let videoControls: boolean = false;
  export let wrapperClasses = '';

  export let imgElement: HTMLImageElement;

  const dispatch = createEventDispatcher<{ onImageLoad: void }>();

  $: src = `${PUBLIC_DO_ASSETS_URL}/${filename}`;
  $: isVideo = type && VIDEO_FORMATS.includes(type.toLowerCase());
  $: isImage = type && IMAGE_FORMATS.includes(type.toLowerCase());
  $: isAnimated = type && ANIMATED_FORMATS.includes(type.toLowerCase());

  function handleLoaded() {
    isLoaded = true;
  }

  function handleImgLoaded() {
    handleLoaded();
    dispatch('onImageLoad');
  }

  afterUpdate(() => {
    if (imgElement && imgElement.complete) {
      handleImgLoaded();
    }
  });
</script>

{#if !filename}
  <p>No source file available</p>
{:else if isVideo}
  <div class="{cn(wrapperClasses)}">
    <Video {src} {captionsSrc} bind:videoControls on:onLoad="{handleLoaded}" />
  </div>
{:else if isAnimated}
  <div class="{cn(wrapperClasses)}">
    <Image {src} {title} bind:imgElement on:load="{handleImgLoaded}" />
  </div>
{:else if isImage}
  <div class="{cn(wrapperClasses)}">
    <button on:click class="cursor-pointer">
      <Image {src} {title} bind:imgElement on:load="{handleImgLoaded}" />
    </button>
  </div>
{:else if previewImage}
  <PreviewImage {title} {previewImage} bind:imgElement on:load="{handleImgLoaded}" />
{/if}
